//--------------------------------------------------------------------------
// <copyright file="msalInstance.js" company="Microsoft">
// Copyright (c) Microsoft Corporation. All rights reserved.
// </copyright>
//--------------------------------------------------------------------------
import { PublicClientApplication } from "@azure/msal-browser";
import { msalConfig } from '../utils/authConfig';

/// <summary>
/// Wrapper over Msal app instance.
/// </summary>

const msalInstance = new PublicClientApplication(msalConfig);

export default msalInstance;